import script from "./ReferenceOverviewSections.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceOverviewSections.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceOverviewSections.vue?vue&type=style&index=0&id=42cc6c4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cc6c4a"]])

export default __exports__